import {
  CompanyOperationalStatus,
  DeliveryMode,
  InvoiceStatus,
  SetupPackageType,
  SubscriptionTerm,
} from '../../../../../services/exports/Constants';

export default {
  sections: {
    people: 'Personnes',
    financial_metrics: 'Indicateurs financiers',
    onboarding_and_quality: 'Onboarding & Qualité',
    subscriptions: 'Abonnements actuels',
    payments: 'Paiements',
    last_invoices: 'Dernières factures',
  },
  fields: {
    google_profile: 'Profil Google',
    owner_name: 'Nom du propriétaire',
    owner_phone_number: 'Tél. propriétaire',
    company_phone_number: 'Tél. restaurant',
    address: 'Adresse',
    onboarding_manager: 'Responsable onboarding',
    sales_manager: 'Responsable commercial',
    last_30_days_sales: 'Revenus des 30 derniers jours',
    lifetime_sales: 'Revenus totaux',
    monthly_sales_other_platforms: 'Ventes applis livraison',
    last_payout: 'Dernier versement',
    potential_tier: 'Score potentiel',
    current_tier: 'Score IST',
    signed_at: 'Date de clôture',
    live_from: 'Date de mise en ligne',
    onboarding_quality_score: 'Score qualité mise en ligne',
    is_google_business_available: 'Google Business disponible',
    is_smart_pricing_configured: 'Prix inférieurs à Lieferando, Wolt, Uber',
    is_flyers_package_sent: 'Flyer promo envoyé',
    is_menu_fully_configured: 'Tous les articles du menu disponibles',
    has_offers_on_competitor_platforms:
      'Le restaurant a-t-il des offres actives sur Wolt, Uber, Lieferando (hors offre livraison gratuite) ?',
    is_instagram_story_shared: 'Story Instagram partagée avec le propriétaire',
    is_order_system_connected_to_website:
      'Site Foodamigos connecté OU bouton commande en ligne ajouté sur le site du restaurant',
    delivery_mode: 'Livreurs',
    has_storefront: 'Site web {{provider}}',
    screening_date: 'Date de sélection',
  },
  setup_fee: {
    title: 'Frais de mise en place',
    status: {
      [InvoiceStatus.Paid]: 'Payé',
      [InvoiceStatus.Pending]: 'En attente',
      [InvoiceStatus.Processing]: 'En cours',
      [InvoiceStatus.Refunded]: 'Remboursé',
      [InvoiceStatus.PartiallyRefunded]: 'Partiellement remboursé',
      [InvoiceStatus.Failed]: 'Échoué',
    },
  },
  labels: {
    yes: 'Oui',
    no: 'Non',
    month: 'Mois',
  },
  operational_status: {
    [CompanyOperationalStatus.Live]: 'Actif',
    [CompanyOperationalStatus.Paused]: 'En pause',
    [CompanyOperationalStatus.Suspended]: 'Résilié',
  },
  setup_packages: {
    [SetupPackageType.Default]: 'Standard',
    [SetupPackageType.Preferred]: 'Pro',
    [SetupPackageType.Custom]: 'Plus',
  },
  contract_terms: {
    [SubscriptionTerm.Monthly]: 'Mensuel',
    [SubscriptionTerm.Annual]: 'Annuel',
  },
  delivery_modes: {
    [DeliveryMode.Internal]: 'Livreurs internes',
    [DeliveryMode.External]: 'Livreurs {{provider}}',
  },
  buttons: {
    view_details: 'Voir les détails',
    open: 'Ouvrir',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
  },
};
